class CollapseTab extends HTMLElement {
    constructor() {
        super()
    }
    connectedCallback() {
        this.button = this.querySelector('button');
        this.collapsibleContent = this.querySelector('.collapsible__content');
        this.button.addEventListener('click', this.toogle.bind(this));
        this.isOpen = !this.collapsibleContent.getAttribute('aria-hidden');
    }
    disconnectedCallback() {
        this.destroy()
    }

    toogle() {
        if(this.isOpen) {
            this.collapsibleContent.style.height = '0px';
            this.collapsibleContent.setAttribute("aria-hidden", "true");
            this.isOpen = false;
            this.removeAttribute("open")
        } else {
            this.collapsibleContent.style.height = this.collapsibleContent.scrollHeight + "px";
            this.collapsibleContent.setAttribute("aria-hidden", "true");
            this.isOpen = true;
            this.setAttribute("open", true);
        }
    }

    destroy() {
        this.trigger.removeEventListener("click", (e=>this.toggle(e))),
        this.content.removeAttribute("aria-hidden"),
        this.content.style.height = "auto",
        this.removeAttribute("open")
    }
}

if (!customElements.get('collapsible-tab')) {
    customElements.define('collapsible-tab', CollapseTab)
}


